import * as Yup from 'yup';
import { FinalCausality } from '../../../../../../shared/types/typifications/finalCausality';

export const initialValues: FinalCausality = {
    code: '',
    finalCausality: '',
    causeNumber: '',
    realCause: '',
    meaning: '',
    description: '',
    active: true,
};

export const validationSchema = () =>
    Yup.object({
        finalCausality: Yup.string().required(
            'La causalidad final es obligatoria'
        ),
        causeNumber: Yup.string()
            .required('El número de causa es obligatorio')
            .test('is-numeric', 'El campo debe ser numérico', (value) =>
                value ? /^\d+$/.test(value) : true
            ),
        realCause: Yup.string().required('La causa real es obligatoria'),
        meaning: Yup.string().required('El significado es obligatorio'),
    });
